import { render, staticRenderFns } from "./LinearGradientBtn.vue?vue&type=template&id=63fb07ac&scoped=true&"
import script from "./LinearGradientBtn.vue?vue&type=script&lang=js&"
export * from "./LinearGradientBtn.vue?vue&type=script&lang=js&"
import style0 from "./LinearGradientBtn.vue?vue&type=style&index=0&id=63fb07ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb07ac",
  null
  
)

export default component.exports